import { OnboardingGoals } from "@/features/onboarding/components/onboarding-questions";

/**
 * Maps legacy pre-2026-08 onboarding goal values (still stored on existing
 * users) to the canonical 3-bucket goals. New values pass through unchanged;
 * unrecognized values (including "Others (Specify)" and free text) are
 * returned as-is so callers keep their own fallback behavior.
 */
const LEGACY_GOAL_TO_CANONICAL: Record<string, string> = {
  [OnboardingGoals.PHONE_CALL]: OnboardingGoals.SALES,
  [OnboardingGoals.INTERVIEW]: OnboardingGoals.RESEARCH,
  [OnboardingGoals.SURVEY_RESPONSE]: OnboardingGoals.RESEARCH,
  [OnboardingGoals.EMBED_RECORDER]: OnboardingGoals.RESEARCH,
  [OnboardingGoals.MEETING_TRANSCRIPTION]: OnboardingGoals.MEETINGS,
  [OnboardingGoals.TRANSLATE_MEDIA]: OnboardingGoals.MEETINGS,
  [OnboardingGoals.APIS]: OnboardingGoals.MEETINGS,
};

export function canonicalizeGoal(goal: string | null | undefined): string {
  if (!goal) return "";
  return LEGACY_GOAL_TO_CANONICAL[goal] ?? goal;
}
